import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DOMPurify = require("dompurify")(window);

function ArticleItem({ name, description, image, slug, date }) {
  const { t } = useTranslation();

  const publishedDate = new Date(date).toLocaleDateString("fr-FR", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <Card>
      <Card.Img variant="top" src={image} alt={name} />
      <Card.Body>
        <Card.Title className="article-card__title">{name}</Card.Title>
        <hr className="article-card__divider" />
        <Card.Text
          className="u-mt-small article-card__description"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(description.slice(0, 264) + "..."),
          }}
        />
        <hr className="article-card__divider" />
        <div className="article-card__meta u-mt-small">
          <Link to={`/blog/${slug}`} className="article-card__read-more">
            {t("article_read_more_link")}
          </Link>
          <span className="article-card__date">{publishedDate}</span>
        </div>
      </Card.Body>
    </Card>
  );
}

export default ArticleItem;
